import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SelectableItemComponent } from "./selectable-item.component";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SelectableItemComponent,
    ],
    exports: [SelectableItemComponent]
})
export class SelectableItemModule { }